import {connect} from "react-redux";
import React from "react";
import Popup from "../../popup";
import Button from "../../../atoms/button";
import ButtonGroup from "../../button-group";
import ActionButton from "../../../atoms/action-button";
import Grid from "../../grid";
import {fetchPickupLocations} from "../../../../state/modules/locations";
import {setCartFulfillmentMethod} from "../../../../state/modules/carts";
import ui from "../../../../util/ui";

class CartFulfillmentView extends React.Component {
    static defaultProps = {
        cart: null,
        release: null,
        onShipping: () => {},
        onPickup: (locationId) => {},
        onCancel: () => {},
    };

    constructor(props) {
        super(props);

        this.state = {
            method: null,
            selectedLocation: null,
        };
    }

    componentDidMount() {
        this.props.fetchPickupLocations();
    }

    handleShipping() {
        this.props.setCartFulfillmentMethod(this.props.cart.id, 0).then(() => {
            this.props.onShipping();
        });
    }

    handlePickupSelection() {
        this.setState({
            method: 'pickup',
        });
    }

    handleLocationSelect(location) {
        this.setState({
            selectedLocation: location,
        });
    }

    handlePickupConfirm() {
        if (!this.state.selectedLocation) {
            ui.notify('Please select a location', 'error');
            return;
        }

        this.props.setCartFulfillmentMethod(this.props.cart.id, 1, this.state.selectedLocation.id).then(() => {
            this.props.onPickup(this.state.selectedLocation.id);
        });
    }

    handleCancel() {
        if (this.state.method === 'pickup') {
            this.setState({
                method: null,
                selectedLocation: null,
            });
        } else {
            this.props.onCancel();
        }
    }

    render() {
        let footer = null;

        if (this.state.method === 'pickup') {
            footer = (
                <ButtonGroup>
                    <Button text={'Cancel'} modifiers={'alt'} onClick={this.handleCancel.bind(this)}/>
                    <Button text={'Confirm'} onClick={this.handlePickupConfirm.bind(this)}/>
                </ButtonGroup>
            );
        }

        return (
            <Popup
                title={'Select fulfillment method for pre-order'}
                footer={footer}
                toggle={true}
                onClose={this.handleCancel.bind(this)}
            >
                {!this.state.method && (
                    <Grid cols={'1fr 1fr'}>
                        <ActionButton modifiers={'xl'} text={'Shipping'} onClick={this.handleShipping.bind(this)}/>
                        <ActionButton modifiers={'xl'} text={'Pickup'} onClick={this.handlePickupSelection.bind(this)}/>
                    </Grid>
                )}

                {this.state.method === 'pickup' && (
                    <div>
                        <h3>Select pickup location</h3>
                        {this.props.pickupLocations && this.props.pickupLocations.length > 0 ? (
                            <ButtonGroup>
                                {this.props.pickupLocations.map(location => (
                                    <Button
                                        key={location.id}
                                        text={location.name}
                                        modifiers={this.state.selectedLocation?.id === location.id ? 'selected' : 'alt'}
                                        onClick={() => this.handleLocationSelect(location)}
                                    />
                                ))}
                            </ButtonGroup>
                        ) : (
                            <p>No pickup locations available</p>
                        )}
                    </div>
                )}
            </Popup>
        );
    }
}

const mapStateToProps = (state) => ({
    pickupLocations: state.locations.pickupLocations,
});

const mapDispatchToProps = {
    fetchPickupLocations: fetchPickupLocations,
    setCartFulfillmentMethod: setCartFulfillmentMethod,
};

export default connect(mapStateToProps, mapDispatchToProps)(CartFulfillmentView);
